import { IRestaurantSettings } from '@backend/domain'
import { ApiHideProperty, ApiProperty, ApiPropertyOptional, OmitType, PickType } from '@nestjs/swagger'
import { IsEmail, IsNotEmpty, IsOptional, IsString } from 'class-validator'

export class RestaurantSettings implements IRestaurantSettings {
	@ApiProperty({ type: String, format: 'email' })
	@IsNotEmpty()
	@IsString()
	@IsEmail()
	email: string

	@ApiPropertyOptional({ type: String })
	@IsOptional()
	@IsString()
	phone?: string

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	address: string

	@ApiHideProperty()
	googlePlaceId: string

	@ApiProperty({ type: String })
	timezone: string
}

export class RestaurantContactSettings extends PickType(RestaurantSettings, ['email', 'phone', 'address']) {}

export class RestaurantSettingsRequest extends RestaurantContactSettings {}

export class RestaurantSettingsResponse extends OmitType(RestaurantSettings, ['googlePlaceId']) {}
